export default __webpack_public_path__ + "static/media/xmarkSelected.9c97cf92.svg";